<template>
	<router-view/>
</template>

<script>
export default {
	name: 'Partner.vue'
}
</script>

<style scoped>

</style>
